<template>
  <div class="setup">
    <Head :title="title"></Head>
    <div class="setup_bottom">
      <div class="firstFloor">
        <van-cell-group inset>
          <van-cell title="账号与安全" is-link to="security" />
          <van-cell title="收货地址" is-link to="Address" />
          <van-cell title="发票抬头" is-link :to="{ path: '/invoice', query: {from: 'setUp'} }" />
        </van-cell-group>
      </div>
      <div class="secondFloor">
        <van-cell-group inset>
          <van-cell title="反馈与建议" is-link to="feedback" />
          <van-cell title="隐私政策" is-link to="mPAgreement" />
          <van-cell title="使用协议" is-link to="apptcp" />
        </van-cell-group>
      </div>
    </div>
    <div class="exit">
      <van-button class="bot" @click="logOut">退出登录</van-button>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import Head from "../components/headTabs.vue";
export default {
  name: "setup",
  data() {
    return {
      title: "设置",
    };
  },
  components: {
    Head,
  },
  methods: {
    to() {
      window.history.go(-1);
    },
    async logOut() {
      await this.$apis.loginServe.logOut();
      this.$store.commit("clearInfo");
      this.$router.push("my");
      Toast("退出成功");
    },
  },
};
</script>

<style lang="scss" scoped>
.setup {
  width: 100vw;
  min-height: 100vh;
  background: #f5f5f5;
  overflow: hidden;
  .setup_top {
    height: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
    line-height: 44px;
    .my {
      width: 72px;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      background: #fff;
    }
  }
  .setup_bottom {
    width: 100%;
    margin-top: 13px;
    .firstFloor {
      width: 100%;
      .van-cell-group--inset {
        margin: 0 12px;
      }
      .van-cell__title span {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
      }
    }
    .secondFloor {
      width: 100%;
      margin-top: 12px;
      .van-cell-group--inset {
        margin: 0 12px;
      }
      .van-cell__title span {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
      }
    }
  }
  .exit {
    width: 100%;
    height: 44px;
    display: flex;
    justify-content: center;
    align-content: center;
    margin-top: 25px;
    .bot {
      width: 94%;
      height: 44px;
      border-radius: 22px;
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      background: #fff;
    }
  }
}
</style>